<template>
  <v-card height="100%">
    <v-data-table
      :headers="headers"
      :items="_clientSchools"
      sort-by="effectiveDate"
      sort-desc
      :item-class="formatCurrent"
    >
      <template v-if="canEdit" v-slot:[`top`]="{}">
        <v-row>
          <v-spacer></v-spacer>
          <client-school-form></client-school-form>
        </v-row>
      </template>
      <template v-slot:[`item.school`]="{ item }">
        <a
          @click="goToSchool(item.school.schoolId)"
          class="text-decoration-underline"
          >{{ item.school.schoolName }}</a
        >
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <client-school-form
          v-if="!viewOnly"
          :clientSchool="item"
        ></client-school-form>
      </template>
      <template
        v-if="
          currentClientSchools.length > 0 &&
          currentClientSchools.length != clientSchools.length
        "
        v-slot:[`footer`]="{}"
      >
        <v-card-actions class="justify-center">
          <v-btn
            @click="showPrevious = !showPrevious"
            small
            text
            color="primary"
            >{{
              Boolean(showPrevious) ? "Hide Previous" : "Show Previous"
            }}</v-btn
          >
        </v-card-actions>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ClientSchoolForm from "./client-school-form";
export default {
  components: { ClientSchoolForm },
  props: ["viewOnly"],
  data() {
    return {
      headers: [
        { text: "School Name", value: "school" },
        { text: "Address", value: "school.streetAddress" },
        { text: "School Contact", value: "school.contact" },
        { text: "Phone", value: "school.phone" },
        { text: "Effective Date", value: "formattedEffectiveDate" },
        { text: "End Date", value: "formattedEndDate" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      showPrevious: false,
    };
  },
  computed: {
    canEdit() {
      return (
        !this.viewOnly &&
        (this.$store.getters["securityModule/isEIAdmin"] ||
          this.$store.getters["securityModule/isSEITAdmin"])
      );
    },
    clientSchools() {
      return (
        this.$store.state.clientModule.selectedClient.clientSchools || null
      );
    },
    _clientSchools() {
      // if on showPrevious || no current schools
      return Boolean(this.showPrevious) || this.currentClientSchools.length == 0
        ? // then show all
          this.clientSchools
        : // else show current only
          this.currentClientSchools;
    },
    currentClientSchools() {
      var today = new Date();
      return this.clientSchools.filter(
        (item) => item.endDate == null || new Date(item.endDate) > today
      );
    },
  },
  methods: {
    formatCurrent(item) {
      let today = new Date();
      if (item.effectiveDate <= today && item.endDate >= today) {
        return "elevation-3";
      }
    },
    goToSchool(schoolId) {
      this.$router.push({ name: "SchoolForm", params: { schoolId: schoolId } });
    },
  },
};
</script>
